











































import Vue, { PropType } from 'vue';
import { Pagination } from '@/api/interfaces/common/pagination';
import FormInputText from '@/components/atoms/formInputText/FormInputText.vue';
import AppPagination from '@/components/molecules/appPagination/AppPagination.vue';
import DatePicker from '@/components/molecules/datePicker/DatePicker.vue';
import FormDropdownCheckboxList from '@/components/molecules/formDropdownCheckboxList/FormDropdownCheckboxList.vue';
import { DateRangeField } from '@/types/forms/fields/dateRangeField';
import { CheckboxesField } from '@/types/forms/fields/checkboxesField';
import { FormOption } from '@/types/forms/formOption';
import { CheckboxListContent } from '@/api/interfaces/content/form/base/checkboxListContent';
import { PlaceholderContent } from '@/api/interfaces/content/form/base/placeholderContent';
import AppButton from '@/components/atoms/appButton/AppButton.vue';
import { ApplicationPaginationContent } from '@/api/interfaces/content/app/applicationPaginationContent';
import { ApplicationUpdateDataModel } from '@/types/app/application/applicationUpdateDataModel';
import { ApplicationStatusDetail } from '@/api/interfaces/content/common/applicationStatusDetail';

export default Vue.extend({
    name: 'ApplicationPagination',
    components: {
        FormInputText,
        AppPagination,
        DatePicker,
        FormDropdownCheckboxList,
        AppButton,
    },
    props: {
        content: {
            type: Object as PropType<ApplicationPaginationContent>,
            required: true,
        },
        pagination: {
            type: Object as PropType<Pagination>,
            required: true,
        },
        applicationUpdateData: {
            type: Object as PropType<ApplicationUpdateDataModel>,
            default: new ApplicationUpdateDataModel(),
        },
        applicationStatusItems: {
            type: Object as PropType<Record<
                string,
                ApplicationStatusDetail
            > | null>,
            default: null,
        },
    },
    data() {
        return {
            queryModel: {
                value: this.applicationUpdateData.query,
            },
            filterDateSentAtModel: new DateRangeField({
                value: {
                    start: this.applicationUpdateData.dateSentAtStart,
                    end: this.applicationUpdateData.dateSentAtEnd,
                },
            }),
            filterStatusModel: new CheckboxesField({
                value: this.applicationUpdateData.statuses,
                options: [],
            }),
            filterStatusContent: {
                options: {},
                ...this.content.filterStatus,
            } as CheckboxListContent & PlaceholderContent,
        };
    },
    computed: {
        page(): number {
            const page =
                1 + Math.floor(this.pagination.offset / this.pagination.limit);
            return isNaN(page) ? 1 : page;
        },
        texts(): { first: string; last: string; count: string } {
            return {
                first: this.content.paginationTextFirst,
                last: this.content.paginationTextLast,
                count: this.content.paginationTextCount,
            };
        },
    },
    watch: {
        'queryModel.value'() {
            this.$emit('query-changed', this.queryModel.value);
        },
        'filterDateSentAtModel.value': {
            handler(): void {
                this.$emit(
                    'date-sent-at-changed',
                    this.filterDateSentAtModel.value,
                );
            },
            deep: true,
        },
        'filterStatusModel.value': {
            handler(): void {
                this.$emit('statuses-changed', this.filterStatusModel.value);
            },
            deep: true,
        },
    },
    created(): void {
        if (!this.applicationStatusItems) {
            return;
        }
        for (const key of Object.keys(this.applicationStatusItems)) {
            if (key == 'deleted') {
                continue;
            }
            this.filterStatusModel.options.push(new FormOption({ key: key }));
            this.filterStatusContent.options[key] = {
                label: this.applicationStatusItems[key].label,
            };
        }
    },
    methods: {
        handlePageChanged(page: number): void {
            this.$emit('page-changed', page);
        },
        handleFilterResetClicked(): void {
            this.queryModel.value = '';
            this.filterDateSentAtModel.value = { start: '', end: '' };
            this.filterStatusModel.value = [];
            this.$emit('filter-reset');
        },
    },
});
